import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import CopyButton from '../../../../base/buttons/CopyButton.web';
import { getDecodedURI } from '../../../../base/util/uri';
const useStyles = makeStyles()(theme => {
    return {
        label: {
            display: 'block',
            marginBottom: theme.spacing(2)
        }
    };
});
/**
 * Component meant to enable users to copy the conference URL.
 *
 * @returns {React$Element<any>}
 */
function CopyMeetingLinkSection({ url, room }) {
    const { classes } = useStyles();
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { style: { color: 'white' } }, t('addPeople.shareLink')),
        React.createElement(CopyButton, { className: 'invite-more-dialog-conference-url copy-btn-styled', displayedText: getDecodedURI(room, url), textOnCopySuccess: t('addPeople.linkCopied'), textOnHover: t('addPeople.copyLink'), textToCopy: getDecodedURI(room, url) })));
}
export default CopyMeetingLinkSection;
